import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';
import macOsScrollBar from 'main/theme/mac-os-scrollbar';

export default makeStyles({ name: 'ContentLayout' })((theme) => ({
    outer: {
        height: '100%',
        flex: 1,
        ...macOsScrollBar({ mx: 4 }),
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            scrollbarWidth: 'none',
            ['&::-webkit-scrollbar']: {
                display: 'none'
            }
        }
    },
    inner: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1200,
        boxSizing: 'border-box',
        margin: 'auto',
        padding: '0 36px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: '0 8px'
        }
    },
    footer: {
        paddingLeft: 0,
        paddingRight: 0
    },
    promo: {
        marginTop: 24
    }
}));
